import { render, staticRenderFns } from "./addcontact.vue?vue&type=template&id=179c613a"
import script from "./addcontact.vue?vue&type=script&lang=js"
export * from "./addcontact.vue?vue&type=script&lang=js"
import style0 from "./addcontact.vue?vue&type=style&index=0&id=179c613a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports